'use strict';

var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');
var configuratorChangeVINMode = require('../components/configuratorChangeVINMode');
const { changeCentreCtas } = require('../changeCentreCtas');

const BREAKPOINTS = {
    sm: 441,
    md: 1024,
    lg: 1440
};

/**
 * Module: configuratorStageConfigure
 * Handling the configure stage of the vehicle configurator UX.
 *
 * Exposes lifecycle methods used by the configurator page to update
 * cart configuration, drive-away price, finance details, cross-border
 * delivery info and small UI behaviours.
 */
const configuratorStageConfigure = {
    /**
     * Last `isNotEligibleForTestDrive` from Variation. Configure-tab reuses this
     * instead of blindly unhiding the footer Test Drive CTA.
     *
     * @type {boolean|null}
     */
    lastIneligible: null,

    /**
     * Central cross-border update handler. Combines three concerns:
     *
     *  1. Fetches Cart-Get and refreshes the cross-border UI panel
     *     (container visibility, alert message, charge text, URL params).
     *
     *  2. [optional] Updates crossBorderDelivery / crossBorderCharge URL
     *     params from the product:afterAttributeSelect response object.
     *
     *  3. [optional] Appends crossBorderDelivery to the default-variant
     *     hidden-input URL so it survives a grade/colour re-selection on
     *     page load (pass variantContext from initDefaultVariation).
     *
     * @param {string} crossBorderDelivery - Value of the crossBorderDelivery URL param.
     * @param {Object} [response]          - afterAttributeSelect response (optional).
     * @param {Object} [variantContext]    - { params, url, $defaultVariant } from
     *                                      initDefaultVariation (optional).
     */
    updateCrossBorderContainer: function (crossBorderDelivery, response, variantContext) {
        var params = new URLSearchParams(window.location.search);
        var crossBorder = $('#cross-border-details-container');
        var crossBorderCartUrl = crossBorder.data('action');
        var showroomStock = params.get('showroomStock') === 'true';
        var responseDelivery = response && response.data && response.data.crossBorderDelivery;
        var responseCharge = response && response.data && response.data.crossBorderCharge;
        var isCrossBorderApplied = !!(crossBorderDelivery || (responseDelivery && responseCharge));

        if (showroomStock) {
            return false;
        }

        $.ajax({
            url: crossBorderCartUrl,
            type: 'get',
            dataType: 'json',
            async: false,
            success: function (data) {
                if (data.totals?.CrossBorderDelivery && data.totals.CrossBorderCharge !== '-') {
                    $('.cross-border-charge').text('$' + data.totals.CrossBorderCharge);
                    crossBorder.removeClass('d-none');
                } else if (!isCrossBorderApplied) {
                    crossBorder.addClass('d-none');
                    frontendUtils.deleteUrlParams('crossBorderDelivery,crossBorderCharge');
                    $('.cross-border-alert-message').addClass('d-none');
                    $('.configurator-footer-change-location-button').removeClass('d-none').addClass('d-flex');
                    changeCentreCtas.patch({ crossBorder: false });
                    $('#summary-cross-border-price-summary').addClass('d-none');
                }
                if (isCrossBorderApplied && data.totals.CrossBorderDelivery && data.totals.CrossBorderCharge !== '-') {
                    var crossBorderChargetxt = $('.cross-border-charge').text();
                    $('.cross-border-alert-message-price').text(crossBorderChargetxt);
                    $('.cross-border-alert-message').removeClass('d-none');
                    frontendUtils.updateUrlParams({
                        'crossBorderCharge': data.totals.CrossBorderCharge
                    });
                    $('.configurator-footer-change-location-button').removeClass('d-flex').addClass('d-none');
                    changeCentreCtas.patch({ crossBorder: true });
                    $('.cross-border-details-container').addClass('d-none');
                }
            }
        });

        // 2. Sync URL params from afterAttributeSelect response.
        if (responseDelivery && responseCharge) {
            frontendUtils.updateUrlParams({
                'crossBorderDelivery': response.data.crossBorderDelivery,
                'crossBorderCharge': response.data.crossBorderCharge
            });
            $('.cross-border-details-container').addClass('d-none');
        }

        // 3. Append crossBorderDelivery to the default-variant URL
        if (variantContext && crossBorderDelivery) {
            var params = variantContext.params;
            var url = variantContext.url;
            var $defaultVariant = variantContext.$defaultVariant;
            params.set('crossBorderDelivery', crossBorderDelivery);
            url.search = params.toString();
            $defaultVariant.val(url.toString());
        }
    },

    /**
     * Binds the click handlers for the cross-border load / remove CTAs
     * that appear in both the configure stage and the summary panel.
     */
    initCrossBorderClickHandlers: function () {
        var showroomStock = new URLSearchParams(window.location.search).get('showroomStock') === 'true';

        if (showroomStock) {
            return;
        }

        $('#load-cross-border-order, #summary-get-cross-border-cta').on('click', function (e) {
            e.preventDefault();
            frontendUtils.updateUrlParams({
                'crossBorderDelivery': true
            });
            location.reload();
        });

        $('body').off('click.crossBorderRemove').on('click.crossBorderRemove', '#remove-cross-border-from-order, #summary-remove-cross-border-price', function (e) {
            e.preventDefault();
            frontendUtils.deleteUrlParams('crossBorderDelivery,crossBorderCharge');

            if (this.id === 'summary-remove-cross-border-price') {
                frontendUtils.updateUrlParams({ 'showSummary': 'true' });
            }

            $('.cross-border-alert-message').addClass('d-none');
            location.reload();
        });
    },

    moveDownloadBrochureContentsToFlyout: function() {
        if(window.innerWidth < BREAKPOINTS.sm) {
            frontendUtils.moveContents('download-brochure-modal-body-header', 'download-brochure-offcanvas-header');
            frontendUtils.moveContents('download-brochure-modal-body-body', 'download-brochure-offcanvas-body');
        }
    },
    updateDownloadBrochureImage: function(product) {
        if (product.productType !== "master") {
            var currentImageUrl = product.images.large[0].url;
            $('.modal-body__header-image').attr('src', currentImageUrl);
            $('.car-item img').attr('src', currentImageUrl);
        }
    },
    setDownloadBrochureModal: function() {
        $('.download-brochure-modal .car-card .car-model-button').trigger('click');
        $('.sidebar__brochure__select-car__text-toggle').hide();
        $('.form-selected-car').removeClass('col-6 col-sm-4').addClass('d-block d-md-flex justify-content-center w-100');
        $('.car-items').addClass('col-6');
        $('.grade-options').addClass('col-6');
        $('.car-item img.clickable').removeClass('clickable');
        $('.sidebar__brochure__details-form').addClass('text-left');
        $('.download-brochure-confirm__donload-another').hide();
        $('.sidebar__brochure__subheading-select-car').hide();
    },
    handelDownloadBrochureGradeChange: function(gradeID) {
        $('[name="car-selected-radio-1"][value="'+gradeID+'"]').trigger('click');
    },
    onDownloadBrochure: function() {
        var $SidebarBrochureContainer = $('.sidebar__brochure__select-container');

        const onDownloadBrochureHandelResponse = function(data) {
            $('.sidebar__brochure__select-container').addClass('d-none');
            $('.form-box-confirmation').addClass('d-block p-5');
            if (!data.error) {
                var buttonHTML = "";
                data.brochureLinks.forEach((item, index) => {
                    buttonHTML += `<span class="d-block mt-2 ">
                        <a target="_blank" class="btn btn-primary w-100" href="${item.BrochurePDFLink}">View ${item.ProductName} brochure</a>
                    </span>`;
                });
                $('.form-box-confirmation-list').html(buttonHTML);
            } else {
                $("#downlod-brochure-error").show();
            }
        };

        $('body').on('download.brochure.beforeLead', function() {
            $SidebarBrochureContainer.spinner().start();
        });

        $('body').on('download.brochure.afterLead.success', function(e, data) {
            onDownloadBrochureHandelResponse(data);
            $SidebarBrochureContainer.spinner().stop();
        });

        $('body').on('download.brochure.afterLead.error', function(e, data) {
            $SidebarBrochureContainer.spinner().stop();
        });
    },
    updateInteriorImage: function (product) {
        if (product.productType !== "master") {
            var $currentInteriorText = $('#interior-text span');
            if (product.customProps.hasOwnProperty('IntColorDesc')) {
                var $currentInteriorImg = $('#interior-img img');
                var $currentInteriorContainer = $('#interior-container');
                if (product.hasOwnProperty('interiorImg')) {
                    $currentInteriorImg.attr('src', product.interiorImg);
                    $currentInteriorImg.attr('alt', product.interiorName);
                    $currentInteriorImg.attr('title', product.interiorTitle);
                    $currentInteriorImg.parent().removeClass('d-none');
                } else {
                    $currentInteriorImg.parent().addClass('d-none');
                }
                $currentInteriorText.text(product.customProps.IntColorDesc);
                if (product.customProps.IntColorDesc) {
                    $currentInteriorText.parent().parent().removeClass('d-none').addClass('d-flex');
                } else {
                    $currentInteriorText.parent().parent().removeClass('d-flex').addClass('d-none');
                }
                $currentInteriorContainer.removeClass('d-none');
            } else {
                $currentInteriorText.parent().parent().removeClass('d-flex').addClass('d-none');
            }
        }
    },
    /**
     * Hide footer and navbar Test Drive CTAs. Flyout rows stay under
     * `syncSummaryNavConsumerCtas` (navbar primary ↔ flyout mutex).
     */
    hideAllTestDriveEntries: function () {
        var $testDriveButtons = $('.configurator-footer-actions-test-drive');
        var $testDriveWrapper = $('.configure-stage__action-test-drive-wrapper');
        var $navTd = $('.configurator-navigation .btn-test-drive');

        $testDriveButtons.addClass('d-none');
        $testDriveWrapper.addClass('d-none');
        $navTd.addClass('d-none disabled').attr('aria-disabled', 'true');
    },

    /**
     * Hide the Options-menu Test Drive row.
     *
     * @private
     */
    hideFlyoutTestDrive: function () {
        var $flyoutTd = $('.configurator-modal .list-group-item-action[data-view="test-drive"]');

        $flyoutTd.addClass('d-none disabled').attr('aria-disabled', 'true');
    },

    /**
     * Ineligible variants hide every Test Drive entry. CXP / modify still hide footer
     * and navbar Test Drive (those slots already have another primary CTA) and then
     * defer the flyout row to `syncSummaryNavConsumerCtas`.
     *
     * @param {boolean} isNotEligibleForTestDrive
     */
    handleTestDriveVisibility: function (isNotEligibleForTestDrive) {
        var $testDriveButtons = $('.configurator-footer-actions-test-drive');
        var $testDriveWrapper = $('.configure-stage__action-test-drive-wrapper');
        var $testDriveEntries = $('.configurator-navigation .btn-test-drive, .configurator-modal .list-group-item-action[data-view="test-drive"]');
        var $summaryPrimaryTestDrive = $('.region--addon-summary .btn-test-drive');

        this.lastIneligible = !!isNotEligibleForTestDrive;

        if (isNotEligibleForTestDrive) {
            this.hideAllTestDriveEntries();
            this.hideFlyoutTestDrive();

            return;
        }

        if (this.flowHidesTestDrive()) {
            this.hideAllTestDriveEntries();

            if (window.configurator && typeof window.configurator.syncSummaryNavConsumerCtas === 'function') {
                window.configurator.syncSummaryNavConsumerCtas();
            }

            return;
        }

        $testDriveButtons.removeClass('d-none');
        $testDriveWrapper.removeClass('d-none');
        $testDriveEntries.removeClass('disabled').removeAttr('aria-disabled');
        $testDriveEntries.not($summaryPrimaryTestDrive).removeClass('d-none');

        if (window.configurator && typeof window.configurator.syncSummaryNavConsumerCtas === 'function') {
            window.configurator.syncSummaryNavConsumerCtas();
        } else {
            $summaryPrimaryTestDrive.removeClass('d-none');
        }
    },

    /**
     * Offline CXP / modify-order: navbar already has a non-TD primary, so footer /
     * navbar Test Drive stay hidden. Flyout Test Drive is decided by the mutex.
     *
     * @private
     *
     * @returns {boolean}
     */
    flowHidesTestDrive: function () {
        return !!(window.configurator
            && typeof window.configurator.getConfiguratorFlowContext === 'function'
            && window.configurator.getConfiguratorFlowContext().suppressesOnlineOrderingCtas);
    },
    updateWheelInfo: function (product) {
        if (product.productType !== 'master') {
            var $wheelsContainer = $('#wheels-container');
            var $wheelsName = $('#wheels-text .wheels-name');
            var $wheelsImg = $('#wheels-img');
            var $wheelsImgTag = $('#wheels-img img');
            var wheels = product.wheels;

            if (!wheels || !wheels.size) {
                $wheelsContainer.addClass('d-none');
                return;
            }

            $wheelsName.text(wheels.size);

            if (wheels.image) {
                $wheelsImgTag.attr('src', wheels.image);
                $wheelsImgTag.attr('alt', wheels.size);
                $wheelsImg.removeClass('d-none');
            } else {
                $wheelsImg.addClass('d-none');
            }

            $wheelsContainer.removeClass('d-none');
        }
    },
    productAfterAttributeSelect: function (response) {
        const updateInteriorImage = this.updateInteriorImage;
        const updateWheelInfo = this.updateWheelInfo;
        const updateDownloadBrochureImage = this.updateDownloadBrochureImage;
        if (response && response.data && response.data.product) {
            updateInteriorImage(response.data.product);
            updateWheelInfo(response.data.product);
            updateDownloadBrochureImage(response.data.product);
            this.updateModelYear(response.data.product);
        }
    },
    updateModelYear: function (product) {
        if (!product) { return; }
        var year = product.inventoryModelYear || '';
        if (year === 'N/A') { year = ''; }
        document.querySelectorAll('.car-explorer--year').forEach(function (el) {
            el.textContent = year;
            el.classList.toggle('d-none', !year);
        });
    },
    initChangeVINMode: function () {
        configuratorChangeVINMode.lockChangeVinMode();
    },

    arjustDOMContentsOnLoad: function() {
        this.setDownloadBrochureModal();
        // this.moveDownloadBrochureContentsToFlyout();
    },
    setupPageListeners: function () {
        /*Events that shoud load on page loat*/
        const productAfterAttributeSelect = this.productAfterAttributeSelect.bind(this);
        const handelDownloadBrochureGradeChange = this.handelDownloadBrochureGradeChange.bind(this);
        const handleTestDriveVisibility = this.handleTestDriveVisibility.bind(this);
        $('body').on('product:afterAttributeSelect', function (el, response) {
            productAfterAttributeSelect(response);
            handelDownloadBrochureGradeChange(response.data.product.customProps.grade);
            handleTestDriveVisibility(response.data.product.customProps.isNotEligibleForTestDrive);
        });

        this.onDownloadBrochure();
    },

    initConfiguratorEvents: function () {
        /* events that be triggred based on customer interactions example cta clicks.*/
        $('#downloadAnotherBrochure,#downloadBrochureConfirm').on('click', function() {
            $('#download-brochure-modal').modal('hide');
        });

        this.initCrossBorderClickHandlers();
    },
    init: function () {
        this.arjustDOMContentsOnLoad();
        this.initConfiguratorEvents();
        this.setupPageListeners();
        this.initChangeVINMode();
    },
}

module.exports = configuratorStageConfigure;
